import { Container, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Missing = () => {
  return (
    <Container className="my-3 text-center">
      <h1>Oops!</h1>
      <p>Page Not Found</p>
      <Link to="/">
        <Button variant="link">Visit Our Homepage</Button>
      </Link>
    </Container>
  );
};

export default Missing;
